import React from "react";
import { TRASH } from "@/constants/testIds";

/**
 * ConfirmDialog — minimal modal used by Order trash flows.
 * Stays in the classic country-club aesthetic: cream surface, serif heading,
 * sharp edges, single-color call to action.
 */
export default function ConfirmDialog({ open, title, message, confirmLabel = "Confirm", cancelLabel = "Cancel", tone = "default", onConfirm, onCancel, busy = false }) {
  if (!open) return null;
  const confirmCls =
    tone === "danger"
      ? "bg-[#8a1a1a] hover:bg-[#A33] text-[#F9F8F4]"
      : "bg-[#1A422D] hover:bg-[#0F2A1C] text-[#F9F8F4]";
  return (
    <div
      data-testid={TRASH.confirm}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-[#1A1A1A]/70"
    >
      <div className="w-full max-w-md bg-[#F9F8F4] border border-[#E5E3D8] shadow-2xl p-7">
        <div className="overline" style={{ color: tone === "danger" ? "#8a1a1a" : "#1A422D" }}>
          {tone === "danger" ? "Confirm Removal" : "Confirm"}
        </div>
        <h3 className="font-serif text-2xl mt-2 text-[#1A1A1A] leading-tight">{title}</h3>
        {message && (
          <p className="text-sm text-[#4A4A4A] mt-3 leading-relaxed">{message}</p>
        )}
        <div className="mt-7 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            data-testid={TRASH.confirmCancel}
            disabled={busy}
            className="btn-secondary text-xs"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            data-testid={TRASH.confirmYes}
            disabled={busy}
            className={`px-5 py-2.5 text-xs uppercase tracking-[0.18em] font-semibold transition-colors ${confirmCls}`}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
